
import Vue from 'vue'

export default Vue.extend({
   name: 'NumberSpinner',
   props: {
      id: String,
      label: String,
      value: { type: Number, required: true },
      step: { type: Number, default: 1 },
      min: { type: Number, default: 0 },
      max: { type: Number, default: 1000 },
      offset: { type: Number, default: 0 },
   },
   data() {
      return {
         initialValue: 0,
         innerValue: 0,
         dirty: false,
      }
   },
   computed: {
      displayValue(): number {
         return this.innerValue + this.offset
      },
   },
   mounted() {
      this.innerValue = +this.value
      this.initialValue = +this.value
   },
   watch: {
      value(newValue: number) {
         if (newValue !== this.innerValue) {
            this.innerValue = +newValue
            this.initialValue = +newValue
         }
      },
   },
   methods: {
      increment() {
         if (this.innerValue < this.max) {
            this.modify(1)
         }
      },
      decrement() {
         if (this.innerValue > this.min) {
            this.modify(-1)
         }
      },
      modify(increment: number) {
         this.innerValue += increment
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         this.$emit('input', this.innerValue)
      },
   },
})
